import React from 'react';
import { Types } from '@wheeebo/polaris-api';
import RotationForm from './RotationForm';
function RotateVehicleGlobalForm({ onSubmit }) {
    return (React.createElement(RotationForm, { message: "Specify the absolute rotation of the vehicle.", onSubmit: (props) => onSubmit(Types.VehicleCommandRotateVehicleGlobal, props) }));
}
export default React.memo(RotateVehicleGlobalForm);
